if (typeof G == 'undefined') G = {};
G.Animations = G.Animations || {};

G.Animations.getTreasureHuntGemBounceAnimation = function getTreasureHuntGemBounceAnimation() {
  var onComplete = new Phaser.Signal();

  return {
    animate: animate,
    onComplete: onComplete,
  };

  function animate(game, target) {
    var gem = G.Utils.find1stObjectWithName(target, "gem");

    if (gem) {
      game.add.tween(gem.scale)
        .to({x: 1.1, y: 1.1}, 50, Phaser.Easing.Bounce.Out, true, 0, 0, true)
        .onComplete.add(onComplete.dispatch, onComplete);
    }
  }

};